import { translatedFieldWithFallback, useRouter } from '@application/utils';
import type { BookingGetProQuery } from '@gql/graphql';
import { useMemo } from 'react';

export const useSeo = (
  pro?: BookingGetProQuery['searchProfessionals']['professionals'][number] | null,
) => {
  const { translate, language } = useRouter();

  const headerTitle = useMemo(() => {
    return translatedFieldWithFallback(language, pro?.translations, 'title');
  }, [language, pro?.translations]);

  const seoTitle = useMemo(() => {
    return translate('booking.seo.title').replace('$proTitle', headerTitle ?? '');
  }, [headerTitle, translate]);

  return { headerTitle, seoTitle };
};
